import React, {useState} from 'react';
import {UseFormReturn} from "react-hook-form";
import CardActions from "../../../components/CardActions";
import {Grid} from "@mui/material";
import {Moneda} from "../../../../../types";
import {ControlledDatePicker, ControlledTextField} from "../../../../../components/forms";
import {FormOperacionTransferenciaTerceros, OperacionTransferenciaTerceros} from "../types/types";
import {dateFormatter} from "../../../../../utils/formatters";
import {OperacionTransferenciaTercerosFields} from "../types/fields";
import {FieldView, SectionBox} from '../../../components/FieldView';

type DatosOperacionProps = {
  formMethods: UseFormReturn<FormOperacionTransferenciaTerceros>
  readOnly?: boolean
  operacion?: OperacionTransferenciaTerceros
  codSistemaPrincipal: number
  nuevo?: boolean
}

function SeccionTransferenciaTercerosDatosOperacion({
                                                      formMethods,
                                                      readOnly,
                                                      operacion,
                                                      codSistemaPrincipal,
                                                      nuevo
                                                    }: DatosOperacionProps) {

  const [monedas, setMonedas] = useState<Moneda[]>([])

  const {control} = formMethods

  return (
    <CardActions title='Datos Operación' icon='mdi:file-document-outline' colapsable>
      <SectionBox>
        {!nuevo && (
          <Grid item xs={12} md={3}>
            <FieldView
              label='Usuario Alta'
              value={`${operacion?.nombreUsuarioAlta} ${operacion?.apellidoUsuarioAlta}`}
            />
          </Grid>
        )}
        <Grid item xs={12} md={3}>
          {readOnly ? (
            <FieldView
              label='Fecha Aprobación'
              value={dateFormatter.toShortDate(operacion?.[OperacionTransferenciaTercerosFields.FechaAprobacion] || '')}
            />
          ) : (
            <ControlledDatePicker
              name={OperacionTransferenciaTercerosFields.FechaAprobacion}
              label='Fecha Aprobación'
              control={control}
              selectedSections={undefined}
              onSelectedSectionsChange={console.log}
              fullWidth
              readOnly={readOnly}
            />
          )}
        </Grid>
        <Grid item xs={12} md={3}>
          {readOnly ? (
            <FieldView
              label='Asesor Financiero'
              value={operacion?.[OperacionTransferenciaTercerosFields.AsesorFinanciero]}
            />
          ) : (
            <ControlledTextField
              control={control}
              name={OperacionTransferenciaTercerosFields.AsesorFinanciero}
              label='Asesor Financiero'
              fullWidth
            />
          )}
        </Grid>
      </SectionBox>
    </CardActions>
  );
}

export default SeccionTransferenciaTercerosDatosOperacion;